var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ios-help-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M12.375,4.587a7.784,7.784,0,1,1-5.508,2.28,7.739,7.739,0,0,1,5.508-2.28m0-1.212a9,9,0,1,0,9,9A9,9,0,0,0,12.375,3.375Z",
    fill: "#67ffe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M16.433,11.25c1.7,0,2.87.943,2.87,2.3a2.218,2.218,0,0,1-1.274,2.013c-.789.458-1.056.793-1.056,1.373v.358H15.4l-.014-.39a1.888,1.888,0,0,1,1.07-2c.766-.458,1.088-.748,1.088-1.31a1.1,1.1,0,0,0-1.219-.975,1.147,1.147,0,0,0-1.215,1.116H13.5c.032-1.46,1.111-2.489,2.933-2.489Zm-1.192,7.771a.974.974,0,1,1,.97.934A.949.949,0,0,1,15.241,19.021Z",
    transform: "translate(-4.027 -3.227)",
    fill: "#67ffe1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/help.d0645f7ecd19ddcde773acccef33b072.svg";